export const CompanyType = Object.freeze({
    C: Symbol('C'),
    E: Symbol('E'),
    N: Symbol('N'),
});

/**
 * Results of this method can be used in <v-select> fields.
 */
export function getItems(value = 'value', text = 'text') {
    let items = [];
    const types = Object.getOwnPropertyNames(CompanyType);

    for (const type of types) {
        items.push({[value]: type, [text]: getTypeText(type)});
    }

    return items;
}

export function getTypeText(status) {
    return {
        [CompanyType.C]: 'Zbierający',
        [CompanyType.E]: 'Wytwarzający',
        [CompanyType.N]: 'Osoba fizyczna',
    }[CompanyType[status]];
}